<script>
  import { SPRITESHEET_URL } from '../../utils/constants';
  import { openOverpanel } from '../../stores/overpanelControl';
  import location from '../../stores/currentLocation';

  let {
    content,
    instructionAriaText,
    locationAriaTemplate,
    editLabelText,
    inOverpanel = false,
    callback = () => {},
    closeCallback = () => {},
    dataTestId = 'location-control',
    locationControl = $bindable(undefined),
  } = $props();

  const onClick = () => {
    openOverpanel('location', {
      closeCallback: () => {
        closeCallback();
        locationControl.focus();
      },
    });
    callback();
  };

  let text = $state(instructionAriaText);
  let ariaLabel = $derived(text);

  location.subscribe((value) => {
    if (value && locationAriaTemplate) {
      text = locationAriaTemplate.replace(
        '{{ADDRESS}}',
        [value.city, value.state, value.zip].filter((val) => val).join(', ')
      );
    } else {
      text = instructionAriaText;
    }
  });
</script>

<button
  class="text-blue-cerulean hover:text-blue-darkish w-full px-4 flex items-center focus:relative focus:outline-none active:shadow-inset-active
    focus:shadow-inset-focus group"
  class:mobile:bg-white={$location && inOverpanel}
  class:mobile:bg-blue-cerulean={!$location}
  class:mobile:text-white={!$location}
  class:mobile:hover:text-white={!$location}
  class:mobile:hover:bg-blue-darkish={!$location}
  class:mobile:active:bg-blue-darkish={!$location}
  class:mobile:focus:bg-blue-darkish={!$location}
  class:md:w-auto={!inOverpanel}
  class:py-3={!inOverpanel}
  class:md:justify-end={!inOverpanel}
  class:md:py-0={!inOverpanel}
  class:md:bg-blue-cerulean={!$location && inOverpanel}
  class:md:text-white={!$location && inOverpanel}
  class:md:hover:text-white={!$location && inOverpanel}
  class:md:hover:bg-blue-darkish={!$location && inOverpanel}
  class:md:active:bg-blue-darkish={!$location && inOverpanel}
  class:md:focus:bg-blue-darkish={!$location && inOverpanel}
  class:bg-white={inOverpanel}
  class:py-4={inOverpanel}
  class:lg:pr-0={!inOverpanel}
  class:lg:pl-16={!inOverpanel}
  data-testid={dataTestId}
  bind:this={locationControl}
  onclick={onClick}
  aria-label={ariaLabel}
>
  {#if $location}
    <svg class="fill-current h-5 w-5 lg:h-6 lg:w-6 mr-4 flex-none" class:md:mr-2={!inOverpanel} role="presentation">
      <use xlink:href="{SPRITESHEET_URL}#location-pin" />
    </svg>
    <div
      class="w-full flex items-baseline justify-between text-sm leading-normal font-medium"
      class:lg:text-base={!inOverpanel}
      class:md:justify-normal={!inOverpanel}
      class:md:w-auto={!inOverpanel}
    >
      <div class="text-nowrap" class:md:font-normal={!inOverpanel} class:md:text-blue-navy={!inOverpanel}>
        {#if $location.city && $location.state}
          <span data-testid="{dataTestId}-city-label">{$location.city},</span>
          <span data-testid="{dataTestId}-state-label">{$location.state}</span>
        {/if}
        {#if $location.zip}
          <span data-testid="{dataTestId}-zip-label">{` • ${$location.zip}`}</span>
        {/if}
      </div>
      <div
        class="ml-2 text-nowrap text-sm font-medium hover-hover:group-hover:underline hover-hover:group-hover:text-blue-navy group-active:underline md:text-blue-cerulean"
      >
        <span class="hidden text-blue-navy font-normal" class:md:inline={!inOverpanel}>(</span>{editLabelText}<span
          class="hidden text-blue-navy font-normal"
          class:md:inline={!inOverpanel}>)</span
        >
      </div>
    </div>
  {:else}
    <svg class="fill-current h-5 w-5 lg:h-6 lg:w-6 mr-4 flex-none" class:md:mr-2={!inOverpanel} role="presentation">
      <use xlink:href="{SPRITESHEET_URL}#location-pin" />
    </svg>
    <div
      class="text-left font-normal leading-tight text-nowrap"
      class:text-sm={!inOverpanel}
      class:lg:text-base={!inOverpanel}
    >
      {@html content}
    </div>
  {/if}
</button>
